export const COOKIE_CONSENT_STORAGE_KEY = 'jm-cookie-consent';
export const COOKIE_CONSENT_AUDIT_STORAGE_KEY = 'jm-cookie-consent-audit';
export const COOKIE_SETTINGS_LINK_LABEL = 'Cookie Settings';
export const DEFAULT_CONSENT_DURATION_DAYS = 180;
export const PRIVACY_POLICY_URL =
  'https://molecularconnections.com/privacy-policy/';
export const COOKIE_POLICY_URL =
  'https://molecularconnections.com/privacy-policy/';

export const getConsentDurationDays = () => {
  const rawValue = import.meta.env.VITE_COOKIE_CONSENT_DURATION_DAYS;
  const parsedValue = Number(rawValue);

  return Number.isFinite(parsedValue) && parsedValue > 0
    ? parsedValue
    : DEFAULT_CONSENT_DURATION_DAYS;
};
